import script from "./CModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CModal.vue?vue&type=script&lang=ts&setup=true"

import "./CModal.vue?vue&type=style&index=0&id=7153e818&scoped=true&lang=scss"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7153e818"]])

export default __exports__